//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import common,{ specState } from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";
import navbar from '@/components/ui/navbar';
import shopCart from '@/components/cusShopCart'


export default {
    components: {navbar,shopCart},
    data(){
        return {
            userInfo: {},
            goodsId: this.$route.query.goodsid,

            goodsData: {
                images: {},
                store_cate: {},
                store:{},
                spec: {},
                spec_name: {},

            },

            cartDialog: {
                show: false
            },
            cartReset:{
                count:1,
                current:0
            },

            favorite: {
                state: false, // 收藏状态，1已收藏，0未收藏
            },
            cartQuantity: 0,

        }
    },
    methods:{

        // 收藏、取消收藏商品
        favoriteHandle(goodsid){

            const _this = this;

            if(!this.userInfo.token){
                this.$vux.confirm.show({
                    title: '提示',
                    content: '收藏商品需要登录.点击确定去登录',
                    onConfirm () {
                        _this.$router.push("/login");
                    },
                    onCancel () {
                        console.log('cancel');
                    }
                })
                return;
            }

            let opts = {
                url: this.favorite.state ? api.favoriteDel : api.favoriteAdd,
                data:{
                    type:'goods',
                    id: goodsid
                },
                type: this.favorite.state ? 'delete' : 'post',
            };

            common.query(opts).then(res => {
                this.favorite.state = !this.favorite.state;
            },res => {
                this.$vux.toast.text(res.message);
            });
        },

        // 查询是否收藏
        queryIsFavorite(){

            if(!this.userInfo.token){
                return;
            }

            const opts = {
                url: api.favoriteGoodsView,
                data: {
                    goods_id: this.goodsId,
                },
                type: 'get'
            }
            common.query(opts).then(res=>{
                this.favorite.state = res.data;
            })
        },

        // 查询商品详情
        queryGoodsDetail(){

            let opts = {
                url: api.goodsDetailInfo,
                data: {
                    id: this.goodsId,
                },
                type:'get'
            };
            common.query(opts).then(res => {
                const handleSpec = new specState(res.data);
                this.goodsData = handleSpec.resolve();
            },
            res => {
                this.$vux.toast.text(res.message);
            }
            );
        },

        // 购物车数量发生变化
        changeCartQuantity(num){
            this.cartQuantity = num;
        },

        // 查询购物车数据
        queryCartCount(){

            const opts = {
                url: api.cartCount,
                data: {},
                type: 'get'
            }
            common.query(opts).then(res=>{
                const count = Number(res.data)
                this.cartQuantity =  count > 0 ? count : 0;
            },res=>{})
        }

    },
    mounted(){
        this.userInfo = common.storageJson('userInfo') || {};

        this.queryGoodsDetail()
        this.queryIsFavorite();
        this.queryCartCount();

    },
}



// WEBPACK FOOTER //
// ./src/views/pages/goodsDetail.vue